import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69f0a17663911b00140b46ff/komhunter/src/app/profile/components/ProfileHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69f0a17663911b00140b46ff/komhunter/src/app/profile/components/StravaConnectionCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69f0a17663911b00140b46ff/komhunter/src/app/profile/components/SyncSettingsCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69f0a17663911b00140b46ff/komhunter/src/components/Sidebar.tsx");
